class Server extends Error {
    constructor(message = 'Internal Server Error. The server encountered an unexpected condition which prevented it from fulfilling the request.') {
      super(message)
      this.name = this.constructor.name
      this.status = 500
      this.errors = []
      Error.captureStackTrace(this, this.constructor)
    }

    addError(error) {
      this.errors.push(error)
    }

    removeError(error) {
      const idx = this.errors.indexOf(error)
      if (idx > -1) this.errors.splice(idx, 1)
    }

    clearErrors() {
      this.errors = []
    }

    hasErrors() {
      return (this.errors.length > 0)
    }
}

module.exports = Server
